var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-wrap bg-white p15"},[(_vm.hidePrompt)?_c('span',{staticStyle:{"color":"#c1121e"}},[_vm._v("温馨提示：")]):_vm._e(),_vm._v(_vm._s(_vm.tips)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }